import '@babel/polyfill';
import 'bootstrap/dist/js/bootstrap.min';
import 'iframe-resizer/js/iframeResizer.contentWindow.min';
import React from 'react';
import ReactDOM from 'react-dom';
import XHR from 'i18next-xhr-backend';
import numeral from 'numeral';
import reactGuard from 'react-guard';

import ApplicationComponent from './components/application/application.component';
import i18nFactory from './lib/i18n/i18nFactory';
import Logger from './Logger';
import createAppStore from './redux';
import { getLocaleFromWindowLocation } from './lib/routerHelper';

function setTranslations() {
  return new Promise((resolve, reject) => {
    try {
      const i18n = i18nFactory('', XHR, () => {
        const language = getLocaleFromWindowLocation() || i18n.language;
        if (language && language !== i18n.language) {
          i18n.changeLanguage(language, () => {
            resolve(i18n);
          });
        } else {
          resolve(i18n);
        }
      });
    } catch (e) {
      reject(e);
    }
  });
}

const initialize = async () => {
  try {
    const i18n = await setTranslations();
    numeral.locale(i18n.language.slice(0, 2));
    document.getElementsByTagName('html')[0].setAttribute('lang', i18n.language);

    reactGuard(React, (err, componentInfo) => {
      Logger.error({
        message: err.message,
        stack: err.stack.split('\n'),
        componentInfo,
      });
    });

    const store = createAppStore(i18n);
    const initialProps = {
      i18n,
      store,
    };
    ReactDOM.render(
      React.createElement(ApplicationComponent, initialProps),
      document.getElementById('root'),
    );
  } catch (err) {
    Logger.error(err);
  }
};

initialize();
